<script>
export default {
  data: ()=>({
    label: undefined
  }),
  mounted(){
    if (this.$el.classList.contains('aoformlabel'))
      this.label = this.$el
    else
      this.label = this.$el.querySelector('.aoformlabel')
  },
  watch:{
    value(val){
      if (!this.label) return
      if (val)
        this.label.classList.add('filled')
      else
        this.label.classList.remove('filled')
    } 
  }
}
</script>

<style lang="sass">
.aoformfield
  border: none
  outline: none
  background: none
  display: block
  width: 100%
  text-align: left
  font-size: 18px
  line-height: 24px
  letter-spacing: 0.04em
  padding: 4px 0
  &[disabled]
    pointer-events: none
  &_pointer
    cursor: pointer
  &_witharrow
    display: flex
    justify-content: space-between
    align-items: center
    svg
      min-width: 10px
      margin: 10px
      margin-right: 8px
      margin-left: 15px
      cursor: pointer
</style>